import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twentyzeroseatertempotraveller() {



const cardData =
{
  keyword: '20 Seater Tempo Traveller for Bhimashankar',
  heading: 'Sanavi Travels: 20 Seater Tempo Traveller for Bhimashankar',
  headingDescription: 'Sanavi Travels offers reliable 20 Seater Tempo Traveller for Bhimashankar, ideal for families, pilgrimage groups, corporate teams, and tourists visiting the sacred Jyotirlinga and the Bhimashankar Wildlife Sanctuary. With AC and Non-AC options, experienced drivers, flexible pickups, and transparent pricing, our service ensures a safe, comfortable, and well-organized outstation journey for darshan and sightseeing.',

  top: 'Key Travel Highlights & Places Around Bhimashankar',

  "topPlaces": [
    {
      "title": "Bhimashankar Jyotirlinga Temple",
      "description": "Bhimashankar is one of the twelve Jyotirlingas of Lord Shiva and a major pilgrimage destination in Maharashtra. Traveling in a 20 seater Tempo Traveller allows devotees to reach together comfortably, reducing fatigue from ghat roads and ensuring timely darshan, especially during early morning aartis and peak seasons."
    },
    {
      "title": "Bhimashankar Wildlife Sanctuary",
      "description": "The sanctuary surrounding Bhimashankar is known for dense forests, scenic trails, and rich biodiversity. Group travel by Tempo Traveller makes it easy to enjoy nature sightseeing, photography stops, and short treks without worrying about multiple vehicles or coordination."
    },
    {
      "title": "Monsoon & Shravan Season Routes",
      "description": "During monsoon and Shravan months, Bhimashankar routes become scenic but challenging. A 20 seater Tempo Traveller with an experienced driver ensures safer navigation through ghats, fog, and wet roads while keeping the group together."
    },
    {
      "title": "Family & Senior Citizen Darshan Trips",
      "description": "Tempo Travellers are well-suited for families and senior citizens visiting Bhimashankar, offering comfortable seating, steady suspension, and easy group movement from pickup to temple drop points."
    },
    {
      "title": "Group Pilgrimage & Yatra Travel",
      "description": "Religious groups, bhajan mandals, and community yatras prefer 20 seater Tempo Travellers for collective travel, allowing shared devotion, organized schedules, and a peaceful pilgrimage experience."
    },
    {
      "title": "Corporate Spiritual & Team Trips",
      "description": "Corporate groups often organize spiritual outings to Bhimashankar. Tempo Traveller travel ensures punctuality, comfort, and professional transport management for such team activities."
    },
    {
      "title": "Weekend & Overnight Tours",
      "description": "Bhimashankar is a popular weekend destination. Tempo Travellers support both one-day darshan trips and overnight tours, giving groups flexibility and comfort throughout the journey."
    },
    {
      "title": "Combined Temple & Nature Tours",
      "description": "Many travelers combine temple visits with nature exploration. A 20 seater Tempo Traveller allows smooth transitions between darshan, forest viewpoints, and local sightseeing spots."
    }
  ],

  "services": [
    {
      "name": "20 Seater Tempo Traveller for Bhimashankar",
      "description": "Sanavi Travels provides dedicated 20 seater Tempo Traveller services for Bhimashankar, designed for comfortable and safe group travel on hilly outstation routes. This service is ideal for pilgrims, families, wedding groups, and corporate teams who want to travel together with proper seating, luggage space, and reliable scheduling. The vehicle setup ensures reduced travel stress, better group coordination, and a smooth pilgrimage experience from departure to return."
    },
    {
      "name": "AC 20 Seater Tempo Traveller Bhimashankar",
      "description": "AC Tempo Travellers offer a relaxed and climate-controlled journey, especially helpful during summer months and long highway travel. Comfortable interiors help passengers remain fresh and focused for darshan."
    },
    {
      "name": "Non AC 20 Seater Tempo Traveller Bhimashankar",
      "description": "Non-AC Tempo Travellers provide a budget-friendly option while maintaining safety and comfort, suitable for groups preferring economical pilgrimage travel."
    },
    {
      "name": "Luxury 20 Seater Tempo Traveller Bhimashankar",
      "description": "Luxury Tempo Travellers feature pushback seats, premium interiors, and enhanced ride comfort, ideal for VIP pilgrims, corporate groups, and special occasions."
    },
    {
      "name": "Tempo Traveller for Family Bhimashankar",
      "description": "Family-focused Tempo Traveller services ensure safe, coordinated, and comfortable travel for all age groups, including elders and children."
    },
    {
      "name": "Tempo Traveller for Corporate Bhimashankar",
      "description": "Corporate Tempo Traveller rentals support spiritual outings, team-building trips, and organized group travel with punctual and professional service."
    },
    {
      "name": "Tempo Traveller for Group Bhimashankar",
      "description": "Group Tempo Traveller services allow religious and social groups to travel together, ensuring unity, timely arrivals, and a peaceful journey."
    },
    {
      "name": "Affordable 20 Seater Tempo Traveller Bhimashankar",
      "description": "Affordable packages offer transparent pricing and dependable service without compromising comfort, making group pilgrimage travel cost-effective."
    },
    {
      "name": "Best Tempo Traveller Service Bhimashankar",
      "description": "Sanavi Travels is trusted for reliable Tempo Traveller services on Bhimashankar routes, known for safety and consistent quality."
    },
    {
      "name": "Tempo Traveller with Driver Bhimashankar",
      "description": "All rentals include experienced drivers familiar with Bhimashankar ghat roads, temple access routes, and traffic conditions."
    },
    {
      "name": "Tempo Traveller for Wedding Bhimashankar",
      "description": "Wedding-related temple visits and rituals are managed smoothly with Tempo Traveller rentals that ensure dignified and timely group travel."
    },
    {
      "name": "Tempo Traveller for Picnic Bhimashankar",
      "description": "Tempo Travellers also support leisure-style picnic trips combined with temple visits and nature exploration."
    },
    {
      "name": "Tempo Traveller for Outstation Bhimashankar",
      "description": "As an outstation destination, Bhimashankar travel benefits from comfortable Tempo Traveller services designed for longer journeys."
    },
    {
      "name": "20 Seater Tempo Traveller for Tour Bhimashankar",
      "description": "Tour-oriented Tempo Traveller packages support flexible itineraries, sightseeing stops, and relaxed group travel."
    },
    {
      "name": "Mini Bus on Rent Bhimashankar",
      "description": "For larger groups, mini bus options are available alongside Tempo Travellers, offering higher seating capacity with similar comfort."
    }
  ],

  "tableData": [
    ["20 Seater Tempo Traveller", "AC Tempo Traveller"],
    ["Non AC Tempo Traveller", "Luxury Tempo Traveller"],
    ["Family Travel", "Group Travel"],
    ["Corporate Trip", "Wedding Travel"],
    ["Outstation Tour", "Pilgrimage Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable Ghat Travel", "WhyChoosedescription": "Tempo Travellers handle hilly Bhimashankar routes smoothly." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Drivers are trained for ghat roads and pilgrimage traffic." },
    { "WhyChooseheading": "Clean & Maintained Vehicles", "WhyChoosedescription": "Vehicles are cleaned and serviced regularly." },
    { "WhyChooseheading": "Group Coordination", "WhyChoosedescription": "Entire group travels together without logistics issues." },
    { "WhyChooseheading": "Multiple Vehicle Options", "WhyChoosedescription": "AC, Non-AC, and luxury Tempo Travellers available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Ideal for Pilgrimages", "WhyChoosedescription": "Designed for temple and yatra travel needs." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for dependable outstation services." }
  ]
};

const faqData = [
  { question: 'Do you provide 20 seater Tempo Traveller for Bhimashankar?', answer: 'Yes, Sanavi Travels offers 20 seater Tempo Traveller services for Bhimashankar trips.' },
  { question: 'Are AC Tempo Travellers available?', answer: 'Yes, AC and Non-AC options are available.' },
  { question: 'Is this service suitable for senior citizens?', answer: 'Yes, the vehicle is comfortable and suitable for elders.' },
  { question: 'Do you include a driver?', answer: 'Yes, all rentals include experienced drivers.' },
  { question: 'Is Bhimashankar treated as outstation travel?', answer: 'Yes, Bhimashankar trips are handled as outstation journeys.' },
  { question: 'Can we plan a one-day trip?', answer: 'Yes, one-day and overnight trips are supported.' },
  { question: 'Are vehicles sanitized before travel?', answer: 'Yes, vehicles are cleaned and sanitized before every trip.' },
  { question: 'Is this service suitable during monsoon?', answer: 'Yes, experienced drivers handle monsoon and ghat routes safely.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup locations can be customized.' },
  { question: 'Do you offer luxury Tempo Traveller options?', answer: 'Yes, luxury 20 seater Tempo Travellers are available.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    feedback: 'Very comfortable Tempo Traveller service for Bhimashankar. Safe driving on ghat roads.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Desai',
    feedback: 'Smooth and well-organized Bhimashankar trip. Highly recommended for group travel.',
    rating: 5
  }
];






































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "20 Seater Tempo Traveller for Bhimashankar - Sanavi Travels",
  "description": "Sanavi Travels offers 20-seater Tempo Travellers for Bhimashankar trips, including family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tours. AC and Non-AC 20-seater Tempo Travellers and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 20 Seater Tempo Traveller for Bhimashankar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 20-seater Tempo Travellers for Bhimashankar with Sanavi Travels. AC & Non-AC vehicles for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/271.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twentyzeroseatertempotraveller;